import { lazy } from 'react'
import { Navigate } from 'react-router-dom'

const RegisterVehicles = lazy(() => import('../../views/toll-system/vehicles/register'))
const TripsHistory = lazy(() => import('../../views/toll-system/trips/history'))
const BundleHistory = lazy(() => import('../../views/toll-system/bundles/history'))
const DashboardConcession = lazy(() =>
    import('../../views/toll-system/dashboard/concession')
)


const TollSystemRoutes = [
    // dashboards
    {
        path: '/toll-system/concession/dashboard',
        element: <DashboardConcession />,
        meta: {
            action: "concesion-level-1",
            resource: "tollSystem"
        }
    },

    //history tickets

    {
        element: <TripsHistory />,
        path: '/toll-system/movements/tickets/list'
    },

    {
        element: <BundleHistory />,
        path: '/toll-system/movements/bundles'
    },

    {
        path: '/toll-system/vehicles/register',
        element: <RegisterVehicles/>
    }

]

export default TollSystemRoutes